import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import Cookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import {
  COOKIES,
  LOCATION_SELECTED,
  VIP_QUALIFIERS_PAGE_TYPE,
} from '../../brands/default/constants';
import { HEADER_ITEMS_LAYOUT } from '../../brands/default/content/components/header';
import { parseWowcherPath } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import { setLocation } from '../../redux/actions/locations';
import AdvertiseLink from './AdvertiseLink';
import HeaderBurgerMenu from './HeaderBurgerMenu';
import HeaderButtons from './HeaderButtons';
import HeaderFlags from './HeaderFlags';
import HeaderLogo from './HeaderLogo';
import HeaderSearch from './HeaderSearch';
import WelcomeText from './WelcomeText';

const HeaderItemsLayout = ({ navigation, path }) => {
  const theme = useContext(ThemeContext);
  const userStore = useSelector((state) => state.user);

  const [location] = useSelector((state) => [state.locations.location]);
  const lightboxLocation = Cookies.load(COOKIES.lightboxLocation);

  const pathUrl = parseWowcherPath(path || '/');
  const isVipHubPage = VIP_QUALIFIERS_PAGE_TYPE.includes(pathUrl.pageType);

  const locationObject = lightboxLocation || location;
  const locationName = locationObject?.shortName;
  const dispatch = useDispatch();
  const hasSelection =
    typeof window === 'undefined'
      ? {}
      : localStorage.getItem(LOCATION_SELECTED);
  useEffect(() => {
    if (lightboxLocation && hasSelection !== 'set') {
      dispatch(setLocation(locationObject, true));
    }
  }, [locationName]);

  return (
    <div className="container">
      <div className="no-gutters">
        <div className="row top-block align-items-center">
          <div className="col text-center">
            <WelcomeText
              // extraClasses={'margin-left-16'}
              isLoggedIn={userStore.isAuthenticated}
              userName={userStore.username}
            />
          </div>
          <div className="d-flex col-auto align-items-end">
            <AdvertiseLink isMobileHidden />
            <div className="flag-wrapper">
              <HeaderFlags
                countryCode={process.env.NEXT_PUBLIC_COUNTRY_CODE}
                isMobileHidden
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="d-md-none col">
            <HeaderBurgerMenu
              isLoggedIn={userStore.isAuthenticated}
              navigation={navigation}
              path={path}
            />
          </div>
          <div className="d-flex col-4 col-md-auto align-items-center justify-content-center text-center">
            <HeaderLogo />
          </div>
          <div className="d-flex justify-content-end col col-md-auto order-md-12">
            <HeaderButtons />
          </div>
          <div className="col-md order-md-1">
            <HeaderSearch
              defaultPlaceholder={
                isVipHubPage && HEADER_ITEMS_LAYOUT.vipSearchPlaceholder
              }
            />
          </div>
        </div>
      </div>
      <style jsx>{`
        .top-block {
          padding-top: 10px;
        }
        .flag-wrapper {
          padding: 3px 0;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .top-block {
            padding-top: 0;
          }
          .flag-wrapper {
            padding: 0;
          }
        }
      `}</style>
    </div>
  );
};
HeaderItemsLayout.propTypes = {
  navigation: PropTypes.array,
  path: PropTypes.string,
};

export default HeaderItemsLayout;
